<mat-card id="field-text-display">
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayoutAlign="center start">
      <p>{{ title }}</p>
    </div>
    <button
      *ngIf="addressArray && addressArray.length >= 1 && isServiceArea"
      mat-icon-button
      (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content class="card-container" [fxHide]="loadContainer">
    <div *ngIf="addressArray && addressArray.length" fxLayout="column" class="panel-border">
      <div
        *ngFor="let idx of addressArray"
        class="loop-container"
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div class="radio-group-container" fxLayout="row">
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-radio-group [(ngModel)]="data.selectAddress">
              <mat-radio-button (change)="onChangeAddress(idx)" [value]="idx._id">
              </mat-radio-button>
            </mat-radio-group>
            <div style="margin-left: 10px" fxLayout="column">
              <p>{{ idx.addressType }}</p>
              <p><b>Name:</b> {{ idx.fullName }}</p>
              <p>
                <b>Address:</b> {{ idx.locality }} {{ idx.houseNo }} {{ idx.city }}
                {{ idx.landmark }}
              </p>
              <p><b>Contact:</b> {{ idx.phoneNumber }}</p>
            </div>
          </div>
          <div fxLayoutGap="10px" fxLayoutAlign="end center">
            <mat-icon (click)="onEdit(idx)" style="color: #6495ed; cursor: pointer">
              edit
            </mat-icon>
            <mat-icon
              *ngIf="addressArray && addressArray.length > 1"
              (click)="onDelete(idx._id)"
              style="color: red; cursor: pointer">
              delete
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div [fxShow]="panelExpand" fxLayout="row" class="panel-border">
      <mat-expansion-panel fxFlex="100" [expanded]="panelExpand">
        <button
          *ngIf="addressArray && addressArray.length"
          class="panel-close-btn"
          (click)="onClosePanel()">
          <mat-icon>close</mat-icon>
        </button>
        <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between start">
          <div fxFlex="49">
            <div class="form-group">
              <label class="fs-14 text-black fw-medium lh-18">Full Name*</label>
              <input
                type="text"
                [(ngModel)]="data.fullName_text"
                class="form-control form--control" />
            </div>
            <div class="form-group mt-10">
              <label class="fs-14 text-black fw-medium lh-18"> Pin Code*</label>
              <input
                type="number"
                min="0"
                [(ngModel)]="data.pinCode_text"
                (keypress)="isPinValid()"
                class="form-control form--control" />
            </div>
            <div class="form-group mt-10">
              <label class="fs-14 text-black fw-medium lh-18">
                House No./ City/ District/ Town *
              </label>
              <input
                type="text"
                [(ngModel)]="data.cityDistrictTown_text"
                class="form-control form--control" />
            </div>
            <div class="form-group mt-10">
              <label class="fs-14 text-black fw-medium lh-18"> Landmark </label>
              <input
                type="text"
                [(ngModel)]="data.landmark_text"
                class="form-control form--control" />
            </div>
            <div class="form-group mt-10">
              <label class="fs-14 text-black fw-medium lh-18"> Phone Number* </label>
              <input
                type="number"
                min="0"
                [(ngModel)]="data.phoneNumber_text"
                (keypress)="isMobValid()"
                class="form-control form--control"
                placeholder="Phone Number" />
            </div>
            <div class="address-type-container mt-10">
              <mat-checkbox [(ngModel)]="data.selectDefault"> Set as Default</mat-checkbox>
            </div>
            <div class="address-type-container mt-10">
              <div style="margin-left: 10px">
                <p><b>Address Type:</b></p>
              </div>
              <mat-radio-group
                style="gap: 1rem; display: flex"
                [(ngModel)]="data.selectAddressType">
                <mat-radio-button *ngFor="let idx of addressTypeArray" [value]="idx.value">
                  {{ idx.name }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div fxLayout="column" fxFlex="49">
            <div class="map-container" [fxShow]="!updateLocation" id="map"></div>
            <div
              fxLayout="column"
              fxLayoutAlign="center center"
              style="width: 100%; height: 450px; margin-top: 15px"
              [fxShow]="updateLocation">
              <span style="font-size: 20px; font-weight: 500; color: rgb(95, 91, 91)">
                Sorry, Location access denied!
              </span>
            </div>
            <div *ngIf="data.latitude_text && data.longitude_text">
              Latitude: {{ data.latitude_text }} Longitude:
              {{ data.longitude_text }}
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-card-content>
  <mat-card-content class="card-container" [fxHide]="!loadContainer">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center">
        <img
          style="height: 300px; width: fit-content"
          src="assets/images/location-not-found.png"
          alt="" />
      </div>
      <div fxLayout="column" fxLayoutAlign="center center">
        <span *ngIf="updateLocation" style="font-size: 25px; margin-bottom: 10px">
          Sorry, Location access denied
        </span>
        <span
          *ngIf="!updateLocation"
          style="font-size: 25px; text-align: left; margin-bottom: 10px">
          Location access allowed
        </span>
        <span *ngIf="updateLocation || locationMessage.length" style="font-size: 18px; color: gray">
          We are curently not serviceable in your area. Please edit or update your adderss.
        </span>
      </div>
    </div>
  </mat-card-content>
  <div fxFlex="100">
    <div [fxHide]="loadContainer" fxLayout="row" fxLayoutAlign="center center">
      <button
        [disabled]="updateLocation"
        [fxShow]="panelExpand"
        mat-flat-button
        (click)="onSaveAddress()"
        class="location-buttons">
        <mat-icon> check_circle </mat-icon>
        <span class="ml-5">Save Address</span>
        <!-- <mat-spinner style="margin: 0 auto" [diameter]="38">
        </mat-spinner> -->
      </button>
      <button
        mat-flat-button
        [fxShow]="!panelExpand && addressArray.length"
        class="location-buttons"
        (click)="onCreate()">
        <mat-icon> home </mat-icon>
        <span class="ml-5"> Add Address </span>
      </button>
      <button
        [fxShow]="
          !panelExpand && addressArray.length && data.selectAddress && data.selectAddress.length
        "
        mat-flat-button
        (click)="onSubmit()"
        class="location-buttons">
        <mat-icon> check_circle </mat-icon>
        <span class="ml-5"> Submit </span>
        <!-- <mat-spinner style="margin: 0 auto" [diameter]="38">
        </mat-spinner> -->
      </button>
    </div>
    <div [fxHide]="!loadContainer" fxLayoutAlign="center center">
      <button
        class="location-buttons"
        mat-flat-button
        [disabled]="updateLocation"
        (click)="onUpdateAddress()">
        <mat-icon> home </mat-icon>
        <span class="ml-5">Add Address</span>
      </button>
    </div>
  </div>
</mat-card>
